import { Link } from "react-router-dom";
import { LockKey } from "@phosphor-icons/react";
import { CENTER_MODULES, useOrganizationConfig } from "@/context/OrganizationConfigContext";
import { useAuth } from "@/context/AuthContext";
import { ROLES } from "@/lib/roles";

export default function ModuleGate({ moduleKey, children }) {
  const { loading, isModuleEnabled, organization } = useOrganizationConfig();
  const { role } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24" aria-label="Loading center configuration">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary/30 border-t-primary" />
      </div>
    );
  }

  if (isModuleEnabled(moduleKey)) return children;

  const module = CENTER_MODULES.find((entry) => entry.key === moduleKey);
  const centerName = organization?.display_name || organization?.name || "this center";
  const canConfigure = role === ROLES.ADMIN;

  return (
    <section
      data-testid={`module-gate-${moduleKey}`}
      className="mx-auto max-w-xl rounded-3xl border border-neutral-200 bg-white p-8 text-center shadow-card"
    >
      <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary-hover">
        <LockKey size={24} weight="duotone" aria-hidden />
      </span>
      <h1 className="mt-4 font-heading text-2xl font-semibold tracking-tight text-neutral-900">
        {module?.label || "This module"} is not active
      </h1>
      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-neutral-600">
        {centerName} has not enabled this supported workflow. No records were changed.
      </p>
      {canConfigure ? (
        <Link
          to="/admin/settings"
          className="mt-5 inline-flex rounded-full bg-primary px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-primary-hover"
        >
          Configure center modules
        </Link>
      ) : null}
    </section>
  );
}
